import React from 'react';
import { MainLayout } from '@layouts';
import { withUser } from '@modules/auth';
import { WebinarsPage } from '@sections/Webinars-Page';
import { getWebinars } from '@modules/get-data';

const Webinars = ({ webinar_cards, webinar_faq }) => {
  return <WebinarsPage webinar_cards={webinar_cards} webinar_faq={webinar_faq} />;
};

Webinars.getLayout = (page) => {
  const { translations } = page.props;
  return (
    <MainLayout
      title={translations.t('site.webinars.meta.title')}
      description={translations.t('site.webinars.meta.description')}>
      {page}
    </MainLayout>
  );
};

Webinars.getInitialProps = async ({ store }) => {
  const { dispatch } = store;
  return await dispatch(getWebinars());
};

export default withUser(Webinars);
